// src/router/index.ts
import { createRouter, createWebHistory } from 'vue-router';
import { isLoggedIn } from '@/utils/auth'; 
import { useDeviceStore } from "@/store/deviceStore";
import { useMessage } from 'naive-ui';

const message = useMessage();

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
    routes: [
        {
            path: "/home",
            redirect: "/",
        },
        {
            path: "/",
            name: "Root",
            component: () => {
                const { isMobile } = useDeviceStore();
                return (isMobile ? import("@/views/m/home.vue") : import("@/views/home.vue"));
            },
            children: [
                {
                    path:"",
                    name: "Homepage",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return (isMobile ? import("@/views/m/page/newhomepage.vue") : import("@/views/newhomepage.vue"));
                    },
                    meta: {
                        public: true,
                        showFooter: true,
                        fullWidth: true,
                        computeHeight: false
                    }
                },
                {
                    path: "calendar",
                    name: "Calendar",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return (isMobile? import ("@/views/m/page/calendar.vue") : import("@/views/calendar.vue"));
                    },
                    meta: {
                        public: true,
                        showFooter: true,
                        fullWidth: false
                    }
                },
                {
                    path: "trial",
                    name: "Trial",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/trial.vue") : import ("@/views/trial.vue"));
                    },
                    meta: {
                        public: true,
                        showFooter: true,
                        fullWidth: false
                    }
                },
                {
                    path:"trial/trialvideo",
                    name: "Video",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/trialvideo.vue") : import ("@/views/trialvideo.vue"))
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: true,
                        fullWidth: false
                    }
                },
                {
                    path:"course",
                    name: "Course",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/course.vue") : import ("@/views/course.vue"))
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: true,
                        fullWidth: false
                    }
                }, 
                {
                    path: "shop",
                    name: "Shop",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/shop.vue") : import ("@/views/shop.vue"))
                    },
                    meta: {
                        public: true,
                        showFooter: true,
                        fullWidth: false
                    }
                },
                {
                    path: "shop/item",
                    name: "Item",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/shopitem.vue") : import ("@/views/shopitem.vue"))
                    },
                    meta: {
                        public: true,
                        showFooter: true,
                        fullWidth: false
                    }
                },
                {
                    path: "customer",
                    name: "Customer",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/customer.vue") : import ("@/views/customer.vue"))
                    },
                    meta: {
                        public: true,
                        showFooter: true,
                        fullWidth: false
                    }
                },
                {
                    path: "filelist",
                    name: "Filelist",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/filelist.vue") : import ("@/views/filelist.vue"))
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: true,
                        fullWidth: false
                    }
                },
                {
                    path: "download",
                    name: "Download",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/download.vue") : import ("@/views/download.vue"))
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: true,
                        fullWidth: false
                    }
                },
                {
                    path: "login",
                    name:"LogIn",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/login.vue") : import ("@/views/login.vue"))
                    },
                    meta: {
                        public: true,
                        showFooter: false,  
                        fullWidth: true
                    }
                },
                {
                    path: "wechat",
                    name:"Wechat",
                    component: () => import ("@/views/wechat.vue"),
                    meta: {
                        public: true,
                        showHeader: false,
                        showFooter: false,
                        fullWidth: true
                    }
                },
                {
                    path: "forgetpassword",
                    name:"ForgetPassword",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/forgetpassword.vue") : import ("@/views/forgetpassword.vue"))
                    },
                    meta: {
                        public: true,
                        showFooter: false,  
                        fullWidth: true
                    }
                },
                {
                    path: "resetpassword",
                    name:"ResetPassword",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/resetpassword.vue") : import ("@/views/resetpassword.vue"))
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: false,  
                        fullWidth: true
                    }
                },
                {
                    path: "reset",
                    name:"Reset",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/reset.vue") : import ("@/views/reset.vue"))
                    },
                    meta: {
                        showFooter: false,  
                        fullWidth: true
                    },
                    beforeEnter: (to, from, next) => {
                        if (to.query.username) {
                            next();
                        } else {
                            next({ path: '/forgetpassword' });
                        }
                    }
                },
                {
                    path: "register",
                    name:"Register",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/register.vue") : import ("@/views/register.vue"))
                    },
                    meta: {
                        public: true,
                        showFooter: false,  
                        fullWidth: true
                    }
                },
                {
                    path: "verify",
                    name:"Verify",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/verify.vue") : import ("@/views/verify.vue"))
                    },
                    meta: {
                        public: true,
                        showFooter: false,  
                        fullWidth: true
                    },
                    beforeEnter: (to, from, next) => {
                        const hasValidParams = to.query.user_id

                        if (hasValidParams) {
                            next();
                        } else {
                            next('/404');
                        }
                    }
                },
                {
                    path: "registered",
                    name:"Registered",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/registered.vue") : import ("@/views/registered.vue"))
                    },
                    meta: {
                        showFooter: false,  
                        fullWidth: true
                    },
                    beforeEnter: (to, from, next) => {
                        if (localStorage.getItem('verified') === 'true') {
                            next();
                        } else {
                            next('/404');
                        }
                    }
                },
                {
                    path: "my",
                    name:"My",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import ("@/views/m/page/my.vue") : import ("@/views/my.vue"))
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: true,  
                        fullWidth: false
                    }
                },
                {
                    path:"my/mycourse",
                    name: "MyCourse",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import("@/views/m/page/mycourse.vue") : import ("@/views/mycourse.vue"))
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: true,  
                        fullWidth: false
                    }
                },
                {
                    path:"my/myquestion",
                    name: "MyQuestion",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import("@/views/m/page/question.vue") : import ("@/views/question.vue"))
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: true,  
                        fullWidth: false
                    }
                },
                {
                    path:"questionlist",
                    name: "QuestionList",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import("@/views/m/page/questionlist.vue") : import ("@/views/questionlist.vue"))
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: true,  
                        fullWidth: false
                    }
                },
                {
                    path:"questiondetail",
                    name: "QuestionDetail",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import("@/views/m/page/questiondetail.vue") : import ("@/views/questiondetail.vue"))
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: true,  
                        fullWidth: false
                    }
                },
                {
                    path:"questionanswer",
                    name: "QuestionAnswer",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import("@/views/m/page/questionanswer.vue") : import ("@/views/questionanswer.vue"))
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: true,  
                        fullWidth: false
                    }
                },
                {
                    path:"questionmark",
                    name: "QuestionMark",
                    component: () => {
                        return import("@/views/questionmark.vue")
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: true,  
                        fullWidth: true
                    }
                },
                {
                    path:"aichat",
                    name: "AIChat",
                    component: () => {
                        const { isMobile } = useDeviceStore();
                        return ( isMobile? import("@/views/m/page/aichat.vue") : import ("@/views/aichat.vue"))
                    },
                    meta: {
                        requiresAuth: true,
                        showFooter: false,  
                        fullWidth: true
                    }
                }
            ]
        }
    ]
});

router.beforeEach(async (to, from, next) => {
  // 公开路由直接放行
  if (to.meta.public) {
    next();
    return;
  }
  
  // 需要登录的路由：实时检查登录状态
  if (to.meta.requiresAuth) {
    // 关键：每次都调用 isLoggedIn() 获取最新状态，而不是用固定的 loginStatus
    const currentLoginStatus = await isLoggedIn(); 
    if (currentLoginStatus) {
      next(); // 已登录，放行
    } else {
      next(`/login?redirect=${to.fullPath}`); // 未登录，跳转登录页
    }
    return;
  }
  
  // 默认放行
  next();
});

export default router;